import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { NgxSpinnerService } from 'ngx-spinner'; // Add this import

@Component({
    selector: 'app-hdfc-callback',
    templateUrl: './hdfc-callback.component.html',
    styleUrls: ['./hdfc-callback.component.scss'],
    standalone: false
})
export class HdfcCallbackComponent implements OnInit {
  isSuccess: boolean | null = null;
  orderId: any;
  status: string;

  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private spinner: NgxSpinnerService // Inject the spinner service
  ) { }

  ngOnInit(): void {
    this.activeRouter.queryParams.subscribe((params) => {
      this.orderId = params['order_id'];
      this.status = params['status'];
      
      this.handleLocalStatus();
    });
  }

  handleLocalStatus() {
    // 1. Manually hide the spinner that the interceptor started
    this.spinner.hide(); 

    console.log("Processing HDFC Status Locally:", this.status);

    if (this.status === 'success') {
      this.isSuccess = true;
      this.storageService.setOrderId(this.orderId);
      this.storageService.setPaymentStatus("payment_successfull");
    } else {
      this.isSuccess = false;
      this.storageService.setPaymentStatus("payment_failed");
    }
  }

  goToOrderList() {
    this.router.navigate(['doqfy/orders/orders-list'], { 
        queryParams: { openOrderId: this.orderId } 
      });
  }
}